import { Compass } from 'lucide-react';
import { EmptyState } from '@/components/ui/empty-state';
import { messages } from '@/messages';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background">
      <header className="border-b bg-background">
        <div className="container flex h-16 items-center gap-2">
          <img src="/nexofacil-icon.png" alt="" className="h-7 w-7" />
          <span className="text-sm font-semibold">NexoFácil</span>
        </div>
      </header>
      <main className="container flex flex-1 items-center justify-center">
        <EmptyState
          icon={Compass}
          size="lg"
          title={messages.empty404Title}
          description={messages.empty404Body}
          action={{ label: messages.ctaBackHome, to: '/' }}
        />
      </main>
      <footer className="border-t bg-background">
        <div className="container py-6 text-center text-xs text-muted-foreground">
          NexoFácil · {new Date().getFullYear()}
        </div>
      </footer>
    </div>
  );
}
